import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';
import { HeadCell, TableCell, Typography } from '../../../../ui-kit';
import { PendingDeliveryLists } from './types';

interface DeliveryListTableHeadCellProps {
    index: number;
    headCell: HeadCell<PendingDeliveryLists>;
}

const DeliveryListTableHeadCell = ({
    index, headCell,
}: DeliveryListTableHeadCellProps) => {
    const { t } = useTranslation();

    const isSticky = index === 0;
    return (
        <TableCell
            id={headCell.id as string}
            key={headCell.id as string}
            align={headCell.align}
            isTableHead
            isSticky={isSticky}
            padding='none'
        >
            <Box p={1}>
                <Typography uppercase color='textSecondary' variant='caption'>{t(...headCell.label)}</Typography>
            </Box>
        </TableCell>
    );
};

export default DeliveryListTableHeadCell;
